<template>
  <div class="file_container">
    <van-nav-bar
      title="护理员请假申请"
      @click-left="$router.push('/')"
      left-arrow
      safe-area-inset-top
      placeholder
    />
    
    <div class="NurseDetail">
      <div class="form">
        <van-field
          v-model="formData.accountName"
          name="医保编码"
          label="医保编码"
          required
          placeholder="请填写医保编码"
          input-align="right"
        />
        <van-field
          readonly
          clickable
          required
          input-align="right"
          label="所属门店"
          :value="selectedStoreName  || formData.storeId"
          placeholder="选择所属门店"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="storeOptions"
            value-key="name"
            @cancel="showPicker = false"
            @confirm="onConfirmStore"
          />
        </van-popup>
      </div>

      <div class="btn">
        <van-button round block type="info" @click="submmit"
          >提交</van-button
        >
      </div>
      <div class="title"></div>
    </div>
  </div>
</template>

<script>
import { checkBind,loadSourceData,bindCode } from "@/api/index";
import { Toast } from "vant";
export default {
  name: "",
  components: {},
  data() {
    return {
      selectedStoreName : "",
      showPicker:false,
      formData: {},
      result: "",
      currentPage: 1,
      columns: [],

    };
  },
  computed: {
    // 将门店数据转换为 picker 需要的格式
    storeOptions() {
      return this.columns.map(store => ({
        text: store.name,
        value: store.id,
        ...store
      }));
    }
  },
  created() {
    this.init();
  },
  methods: {
    //页面数据初次请求 
    init() {
      checkBind().then((res) => {
        if (res.data.success) {
          this.result = res.data.result;
          // console.log(this.result);
          if(this.result == 0){
            this.nurseChangeHandle();
          }else{
            this.$router.push({
              path: '/bindCode',
            });
          }
        } else {
          Toast.fail(res.data.message);
        }
      });
    },
    nurseChangeHandle(){
      loadSourceData().then((res) => {
        if (res.data.success) {
          this.columns = res.data.result;
        }else{
          Toast.fail(res.data.message);
        }
      });
    },
    onConfirmStore(value, index) {
      // value 是选中的整个对象
      this.formData.storeId = value.id;
      this.selectedStoreName = value.name;
      this.showPicker = false;
    },
    submmit() {

      // let info = JSON.parse(localStorage.getItem("info"));
      // this.formData.salesman = info.id;
      // this.formData.salesName = info.realname;
      // this.formData.emType=1;
      // if (!this.formData.name) {
      //   Toast("请填写用户姓名!");
      //   return false;
      // }
      if (!this.formData.storeId) {
        Toast("请填写医保编码!");
        return false;
      }
      if (!this.formData.storeId) {
        Toast("请选择所属门店!");
        return false;
      }
      // console.log(this.formData);
      bindCode(this.formData).then((res) => {
        if (res.data.success) {
          this.$router.push({
            path: '/bindCode',
          });
        }else{
          Toast.fail(res.data.message);
        }
      });
      
    },
  },
};
</script>
<style lang="less" scoped>
.file_container {
  background-color: rgba(232, 232, 232, 0.815);
  min-height: 100vh;
}

/deep/ .van-nav-bar {
  background: #0dacf4;

  .van-nav-bar__title {
    color: #fff;
  }
}

/deep/ .van-nav-bar__left {
  .van-icon {
    color: #fff;
  }
}

/deep/ .van-search__content {
  border: 1px solid #4cc5f8;
}

/deep/ .btnSearch {
  position: relative;
  margin-left: -60px;
  background: linear-gradient(-90deg, #84f5de, #4cc5f8);
  z-index: 99;
  text-align: center;
  color: white;
  border-radius: 0 18px 18px 0;
  border: 1px solid #4cc5f8;
}

.box_container {
  width: 100%;

  .box {
    width: 9.22667rem;
    height: 4.18667rem;
    background: #ffffff;
    border-radius: 0.16rem;
    margin: 0.37333rem;

    .b_center {
      font-size: 0.42667rem;
      padding: 0.53333rem 0.42667rem 0 0.42667rem;
      .b_center_title{
        color: #666666;
        line-height: 0.72rem;
      }
    }

    .btn_item {
      margin: 0 auto;
      width: 2rem;
      /deep/ .van-button {
        width: 62px;
        height: 28px;
        margin-top: 10px;
        .van-button--round {
          border-radius: 20px;
        }
      }
    }

    .d_right {
      width: 28px;
      height: 28px;
      background: linear-gradient(-90deg, #84f5de, #4cc5f8);
      border-radius: 50%;

      &::before {
        content: ">";
        width: 20px;
        height: 20px;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        margin-left: 6px;
      }
    }
  }
}
.page {
  margin-top: 20px;
}
</style>
